/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : models/configuration/index.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Interface definitions for Configuration related data
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 28, 2021
 *
 * @Version      : Version 1.0
 *
 * By            :
 * On            :
 * Description   :
 *
 *
 ******************************************************************************/

import { ISavedNewAPMFileDetails } from "../aircraftDetails/index";

export interface IApmFileData {
  customerName: string;
  fileName: string | null;
  tailNumber: string;
  status: string;
  serialNumber: string;
  customerPhone: string | null;
  customerEmail: string | null;
  customerId: string;
  createdOn: string;
  aircraftModel: string;
  aircraftMake: string;
  platform: string;
  previousScreen: string | null;
  historyId: number;
}

export interface IApmFilesHistoryState {
  data: IApmFileData[];
  loading: boolean;
}

export enum EnumApmSettingsWorkFlow {
  New = "New",
  Edit = "Edit",
  History = "History",
  Preview = "Preview",
}

export enum EnumHeaderAction {
  customerChange = "customerChange",
  apmHistory = "apmHistory",
  createNewApm = "createNewApm",
}

export enum EnumNavigateAction {
  skip = "skip",
  next = "next",
  save = "save",
}

export enum EnumCurrentApmFileRecordStatus {
  inProgress = "IN_PROGRESS",
  completed = "COMPLETED",
}

export interface IApmWorkFlowState {
  workFlow: {
    currentWorkFlowType: EnumApmSettingsWorkFlow;
    currentWorkFlowStep: number;
  };
  selectedApmRecordLoader: boolean;
  currentApmFileRecord: ISavedNewAPMFileDetails | null;
}
